import * as React from 'react';
import { connect } from 'react-redux';

import SimpleArtist from '@common/types/artist/simple-artist';

import AppState from '@webapp/store/state';
import ArtistListItem from '@components/artist/artist-list-item/index';

interface NavbarItemAvatarCtrlProps {
  className?: string;
  onHeader?: boolean;
  noHover?: boolean;
  noIcons?: boolean;
  noTruncate?: boolean;
  artist?: SimpleArtist;
}

const mapStateToProps = (state: AppState) => ({
  artist: state.artist.active,
});

export const NavbarItemAvatarCtrl: React.FC<NavbarItemAvatarCtrlProps> = (
  props
) => {
  return props.artist ? (
    <ArtistListItem
      className={props.className}
      onHeader={props.onHeader}
      artist={props.artist}
      noHover={props.noHover}
      noIcons={props.noIcons}
      noTruncate={props.noTruncate}
    />
  ) : null;
};

export default connect(mapStateToProps)(NavbarItemAvatarCtrl);
